import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getMeApi } from '~/features/auth/api/get-me.api';

import type { AuthUser } from '~/features/auth/types/auth.type';

export interface AuthState {
  isLoading: boolean;
  authUser: AuthUser | null;
}

const initialState: AuthState = {
  isLoading: true,
  authUser: null,
};

/**
 * 현재 로그인한 관리자 정보 조회
 */
export const fetchMe = createAsyncThunk<AuthUser>(
  'auth/fetchMe',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getMeApi();
      return data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const AuthSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    resetAuthUser: state => {
      state.authUser = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMe.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.authUser = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMe.rejected, state => {
        state.authUser = null;
        state.isLoading = false;
      });
  },
});

export const { resetAuthUser } = AuthSlice.actions;
export default AuthSlice;
